import React, { useState, useRef, useEffect } from "react";
import { FiVolume2 } from "react-icons/fi";
import { AiOutlineSwap } from "react-icons/ai";
import { FaMicrophone, FaStop } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import sidebarBg from "../assets/BGmap.png";
import logo from "../assets/conversation.png";
import eaii from "../assets/logo.jpg";
import newchat from "../assets/record-img.png";
import emoji from "../assets/emoji.png";
import axios from "axios";
import { TailSpin } from "react-loader-spinner";
import { FiCopy, FiTrash } from "react-icons/fi";

const apiKey = process.env.REACT_APP_API_URI;

const Conversation = ({
  languageDropdown,
  getTranslation,
  selectedLanguage,
}) => {
  const [languages, setLanguages] = useState({
    original: selectedLanguage === "amharic" ? "አማርኛ" : "Afaan Oromoo",
    target: selectedLanguage === "amharic" ? "Afaan Oromoo" : "አማርኛ",
  });

  useEffect(() => {
    setLanguages({
      original: selectedLanguage === "amharic" ? "አማርኛ" : "Afaan Oromoo",
      target: selectedLanguage === "amharic" ? "Afaan Oromoo" : "አማርኛ",
    });
  }, [selectedLanguage]);
  const [isRecording, setIsRecording] = useState(false);
  const [recordings, setRecordings] = useState([]);
  const [loadingReply, setLoadingReply] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [history, setHistory] = useState([]);
  const [activeHistoryIndex, setActiveHistoryIndex] = useState(null);
  const mediaRecorderRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const audioChunksRef = useRef([]);
  const currentAudioRef = useRef(null);
  const navigate = useNavigate();
  const languageCode = {
    አማርኛ: "AM",
    "Afaan Oromoo": "OR",
  };
  const [showNewChatImage, setShowNewChatImage] = useState(true);

  const playRecording = (url) => {
    playAudio(url);
  };

  const playReply = (url) => {
    playAudio(url);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {});
  };

  const playAudio = (url) => {
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current.currentTime = 0;
    }

    const audio = new Audio(url);
    currentAudioRef.current = audio;

    audio.play();
    audio.onended = () => {
      currentAudioRef.current = null;
    };
  };
  const messagesEndRef = useRef(null);

  const handleSwapLanguages = () => {
    setLanguages((prevLanguages) => ({
      original: prevLanguages.target,
      target: prevLanguages.original,
    }));
  };

  const startRecording = () => {
    if (loadingReply) {
      setErrorMessage(getTranslation("loadingReplyError"));
      return;
    }

    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        mediaRecorderRef.current = new MediaRecorder(stream);
        audioChunksRef.current = [];

        mediaRecorderRef.current.ondataavailable = (event) => {
          audioChunksRef.current.push(event.data);
        };

        mediaRecorderRef.current.start();
        setIsRecording(true);
        setErrorMessage(null);
      })
      .catch((error) => {
        console.error("Error accessing microphone:", error);
        setErrorMessage("Microphone access is required to record audio.");
      });
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      mediaRecorderRef.current.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, {
          type: "audio/wav",
        });
        const audioUrl = URL.createObjectURL(audioBlob);

        const updatedRecordings = [
          ...recordings,
          {
            url: audioUrl,
            blob: audioBlob,
            transcription: null,
            apiAudio: null,
            originalLanguage: languages.original,
            targetLanguage: languages.target,
          },
        ];
        setRecordings(updatedRecordings);
        setLoadingReply(true);
        setErrorMessage(null);
        setShowNewChatImage(false);

        try {
          const appId = localStorage.getItem("app-id");
          if (!appId) {
            throw new Error("App ID not found. Please register the app first.");
          }

          const formData = new FormData();
          formData.append("app-id", appId);
          formData.append("source-language", languageCode[languages.original]);
          formData.append(
            "destination-language",
            languageCode[languages.target]
          );
          formData.append("audio-file", audioBlob);

          const response = await axios.post(
            `${apiKey}/api/translate`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );

          console.log("API Response:", response.data);

          if (response.data) {
            const transcription =
              response.data.transcription || "No transcription available.";
            const apiAudio = `data:audio/wav;base64,${response.data.audio}`;

            const withReply = updatedRecordings.map((rec, index) =>
              index === updatedRecordings.length - 1
                ? { ...rec, transcription, apiAudio }
                : rec
            );
            setRecordings(withReply);
            setErrorMessage(null);
          } else {
            throw new Error("Invalid API response.");
          }
        } catch (error) {
          console.error("Error during translation:", error);
          const errorMessage =
            error.response?.data?.message ||
            "Translation failed. Please try again.";
          const withError = updatedRecordings.map((rec, index) =>
            index === updatedRecordings.length - 1
              ? { ...rec, transcription: errorMessage }
              : rec
          );
          setRecordings(withError);
        } finally {
          setLoadingReply(false);
        }
      };

      setIsRecording(false);
    }
  };

  const registerApp = async () => {
    try {
      const response = await axios.post(`${apiKey}/api/register-app`);
      const appId = response.data["app-id"];
      if (appId) {
        localStorage.setItem("app-id", appId);
      }
    } catch (error) {
      console.error("Error registering the app:", error);
      setErrorMessage("Failed to register the app. Please refresh the page.");
    }
  };
  useEffect(() => {
    if (!loadingReply) {
      setErrorMessage(null);
    }
  }, [loadingReply]);
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [recordings]);
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [recordings]);

  useEffect(() => {
    const appId = localStorage.getItem("app-id");
    if (!appId) {
      registerApp();
    }
  }, []);

  return (
    <div
      className="w-full h-[calc(100vh-40px)] bg-cover bg-center"
      style={{
        backgroundImage: `url(${sidebarBg})`,
      }}
    >
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <TailSpin
            height="80"
            width="80"
            color="#FFFFFF"
            ariaLabel="loading"
          />
        </div>
      )}

      <div className="flex flex-col lg:flex-row h-screen">
        {/* Sidebar */}
        <div className="w-full lg:w-[400px] h-full lg:h-screen bg-gradient-to-br from-[#161A61] to-[#121E5A] border-r border-[#F9F9F9] relative">
          {/* Back Button */}
          {/* <div className="absolute top-5 left-5">
  <button
    className="flex items-center gap-2 text-white hover:opacity-80 transition"
    onClick={() => {
      setIsLoading(true); 
      setTimeout(() => {
        navigate("/"); 
        setIsLoading(false); 
      }, 1000); 
    }}
  >
    <IoArrowBack size={24} />
    {getTranslation("back")}
  </button>
</div> */}

          <div className="absolute top-[20px] lg:top-[69.62px] inset-x-0 mx-auto flex flex-col items-center">
            <div className="border-[10px] border-white rounded-full w-[80px] h-[80px] lg:w-[96.76px] lg:h-[96.76px] flex justify-center items-center">
              <img
                src={logo}
                alt="Conversation Logo"
                onClick={() => {
                  setIsLoading(true);
                  setTimeout(() => {
                    navigate("/");
                    setIsLoading(false);
                  }, 1000);
                }}
              />
              {getTranslation("back")}
            </div>
            <div className="text-center mt-4 px-4 flex flex-col w-full">
              <h1 className="text-white text-2xl font-bold h-[50px] text-start pt-4 lg:pt-12">
                {getTranslation("conversationTitle")}
              </h1>
              <p className="text-white text-sm lg:text-lg font-AbbaGarima text-start w-[258px] h-auto lg:h-[170px] lg:pt-20">
                {getTranslation("conversationDescription")}
              </p>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex flex-col w-full h-screen">
          <div
            className="w-full h-[60px] py-2 bg-[#FFFFFF] shadow-md border-b border-[#F9F9F9] flex justify-end items-center px-4"
            style={{
              boxShadow: "0px 4px 4px 0px #DCEDFF",
            }}
          >
            {languageDropdown}
            <img
              src={eaii}
              alt="EAII Logo"
              className="w-10 h-10 object-contain rounded-full border-2 border-white shadow-md"
            />
          </div>

          <div className="flex flex-nowrap lg:flex-nowrap flex-1 justify-start py-5">
            {/* Left Box */}

            <div className="relative w-full h-[100%]  bg-white border border-blue-400 mx-4 rounded-lg shadow-sm flex flex-col justify-between">
              {/* Delete Chat Button */}
              {!loadingReply &&
                recordings.length > 0 &&
                recordings.some((rec) => rec.transcription) && (
                  <div className="flex justify-end mt-5 px-4">
                    <button
                      className="bg-[#2C3071] text-white px-4 py-2 rounded-md"
                      onClick={() => {
                        if (isRecording) {
                          stopRecording();
                        }
                        setRecordings([]);
                        setHistory([]);
                        setActiveHistoryIndex(null);
                        setShowNewChatImage(true);
                        setErrorMessage(null);
                        setLoadingReply(false);
                      }}
                    >
                      <FiTrash />
                    </button>
                  </div>
                )}

              <div className=" px-32 h-[420px] overflow-y-auto flex justify-center ">
                {showNewChatImage ? (
                  <img
                    src={newchat}
                    alt="New Chat"
                    className="w-[800vw] max-w-[700px] h-full   object-contain"
                  />
                ) : (
                  <div className="flex flex-col space-y-4 w-full ">
                    {(activeHistoryIndex === null
                      ? recordings
                      : history[activeHistoryIndex]?.chats || []
                    ).map((recording, index) => (
                      <React.Fragment key={index}>
                        <div className="flex items-center  bg-[#2C3071] text-white rounded-lg px-3 py-4">
                          <p className="text-sm">
                            {recording.originalLanguage}
                          </p>
                          <button
                            onClick={() => playRecording(recording.url)}
                            className="ml-2 bg-blue-500 p-1 rounded-full"
                          >
                            <FiVolume2 />
                          </button>
                        </div>
                        {loadingReply && index === recordings.length - 1 && (
                          <div className="flex flex-col items-center ml-6 mt-2 ">
                            <TailSpin
                              height="40"
                              width="40"
                              color="#2C3071"
                              ariaLabel="loading"
                            />
                          </div>
                        )}

                        {recording.transcription && (
                          <div className="bg-blue-200 text-black rounded-lg p-3 relative">
                            <div className="flex items-center justify-between">
                              <p className="text-sm">
                                {recording.targetLanguage}
                              </p>
                              <div className="flex items-center space-x-2">
                                {/* Play Transcription Audio */}
                                {recording.apiAudio && (
                                  <button
                                    onClick={() =>
                                      playReply(recording.apiAudio)
                                    }
                                    className="bg-blue-500 p-1 rounded-full text-white"
                                  >
                                    <FiVolume2 />
                                  </button>
                                )}

                                {/* Copy Button */}
                                {!recording.transcription.includes(
                                  "Translation failed"
                                ) && (
                                  <button
                                    onClick={() =>
                                      copyToClipboard(recording.transcription)
                                    }
                                    className="p-1 rounded-full text-gray-700 transition"
                                  >
                                    <FiCopy size={18} />
                                  </button>
                                )}
                              </div>
                            </div>

                            {/* Transcription Text */}
                            <p className="text-sm mt-2">
                              {recording.transcription}
                            </p>
                          </div>
                        )}
                      </React.Fragment>
                    ))}
                    <div ref={messagesEndRef} />
                  </div>
                )}
              </div>
              {/* Mic Button */}
              <div className="flex flex-col bg-white  items-center ">
                {!errorMessage && (
                  <p className="mb-2 text-gray-600 ">
                    {isRecording
                      ? getTranslation("recording")
                      : getTranslation("clickToRecord")}
                  </p>
                )}

                {errorMessage && (
                  <p className=" text-red-500 text-sm mt-1">{errorMessage}</p>
                )}
                <button
                  className={`w-[60px] h-[60px]  ${
                    isRecording
                      ? "bg-red-500 shadow-[0px_0px_15px_#ff0000]"
                      : "bg-white shadow-[0px_0px_15px_#2C3071]"
                  } rounded-full flex items-center justify-center border text-[#2C3071] `}
                  onClick={isRecording ? stopRecording : startRecording}
                >
                  {isRecording ? (
                    <FaStop size={24} className="text-white" />
                  ) : (
                    <FaMicrophone size={24} className="text-[#2C3071]" />
                  )}
                </button>
              </div>

              <div
                className="min-h-16 w-[calc(100%-2rem)] max-w-[480px] bg-[#2C3071] grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] my-auto items-center gap-2 rounded-[7px] px-3 py-3 mx-auto sm:gap-4 sm:px-4"
              >
                {/* Original Language */}
                <div className="flex min-w-0 items-center gap-2 text-white">
                  <img
                    src={emoji}
                    alt={languages.original}
                    className="h-6 w-6 shrink-0 p-1 bg-white rounded-full"
                  />
                  <p className="min-w-0 text-sm font-ethiopic text-center whitespace-normal break-words">
                    {languages.original}
                  </p>
                </div>

                {/* Swap Icon */}
                <div className="flex items-center justify-center">
                  <AiOutlineSwap
                    size={32}
                    className="text-white cursor-pointer hover:opacity-80 transition "
                    onClick={handleSwapLanguages}
                  />
                </div>

                {/* Target Language */}
                <div className="flex min-w-0 items-center justify-end gap-2 text-white">
                  <p className="min-w-0 text-sm font-ethiopic text-center whitespace-normal break-words">
                    {languages.target}
                  </p>
                  <img
                    src={emoji}
                    alt={languages.target}
                    className="h-6 w-6 shrink-0 p-1 bg-white rounded-full scale-x-[-1]"
                  />
                </div>
              </div>
            </div>

            {/* Right Box */}
            {/* <div className="relative w-full lg:w-[30%] bg-white border border-white m-4 rounded-lg shadow-sm">
              <div className="h-10 bg-blue-500 rounded-t-lg flex items-center justify-center text-white text-lg font-bold">
              </div>
              <div className="p-4 space-y-4 overflow-y-auto max-h-[80vh] bg-gray-200 opacity-50 pointer-events-none">
                <p className="text-center text-gray-700">Feature will be added in Version 2</p>
              </div>
            </div> */}
          </div>
          {/* Footer */}
          <footer className="bg-gray-100 py-3 flex justify-center items-center gap-2 text-center mt-auto">
            <p className="text-gray-700 text-sm font-medium">
              {getTranslation("providedBy")}Ethiopian Artificial Intelligence
              Institute © 2025
            </p>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Conversation;
